"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _reduxActions = require("redux-actions");

var _httpActions = require("../actions/http-actions");

var _achActions = require("../actions/ach-actions");

var _util = require("./util");

var _handleActions;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var initialState = {
  logins: [],
  items: [// {
    //   uuid,
    //   itemId: '',
    //   institution: '',
    //   accounts: [{
    //     id: '',
    //     name: '',
    //     accountType: '',
    //     accountNumberMask?: ''
    //   }],
    //   assetsComplete: false,
    //   assetsFailed: false,
    //   loginRequired: false,
    //   inProgress: false,
    //   retryable: false,
    //   status: [PENDING, UPDATING, NEEDS_LOGIN, FAILED, FAILED_NO_RETRY, COMPLETE],
    // }
  ],
  loading: false,
  error: ''
};
exports.initialState = initialState;
var reducer = (0, _reduxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, "".concat(_achActions.GET_ACH_LOGINS, "_").concat(_httpActions.REQUEST), function _() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  return _objectSpread(_objectSpread({}, state), {}, {
    loading: true
  });
}), (0, _defineProperty2.default)(_handleActions, (0, _reduxActions.combineActions)("".concat(_achActions.SAVE_PLAID_AUTH_LINK, "_").concat(_httpActions.REQUEST), "".concat(_achActions.CREATE_PLAID_ITEM_PUBLIC_TOKEN, "_").concat(_httpActions.REQUEST), "".concat(_achActions.CREATE_PLAID_LINK_TOKEN, "_").concat(_httpActions.REQUEST), "".concat(_achActions.EXCHANGE_PLAID_PUBLIC_TOKEN, "_").concat(_httpActions.REQUEST), "".concat(_achActions.UPDATE_PLAID_ITEM, "_").concat(_httpActions.REQUEST), "".concat(_achActions.DELETE_PLAID_ITEM, "_").concat(_httpActions.REQUEST)), function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    error: ''
  });
}), (0, _defineProperty2.default)(_handleActions, "".concat(_achActions.GET_ACH_LOGINS, "_").concat(_httpActions.SUCCESS), function _(state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    logins: action.payload,
    // just replace
    loading: false
  });
}), (0, _defineProperty2.default)(_handleActions, "".concat(_achActions.GET_PLAID_ASSETS, "_").concat(_httpActions.SUCCESS), function _(state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    items: action.payload.items.map(function (item) {
      return _objectSpread(_objectSpread({}, item), {}, {
        // map statuses to flags so its easier for consumers to do stuff without inspecting specific statuses
        assetsComplete: item.status === 'COMPLETE',
        assetsFailed: ['NEEDS_LOGIN', 'FAILED', 'FAILED_NO_RETRY'].includes(item.status),
        loginRequired: item.status === 'NEEDS_LOGIN',
        inProgress: ['PENDING', 'UPDATING'].includes(item.status),
        retryable: item.status === 'FAILED'
      });
    }),
    loading: false
  });
}), (0, _defineProperty2.default)(_handleActions, (0, _reduxActions.combineActions)("".concat(_achActions.SAVE_PLAID_AUTH_LINK, "_").concat(_httpActions.FAILURE), "".concat(_achActions.CREATE_PLAID_ITEM_PUBLIC_TOKEN, "_").concat(_httpActions.FAILURE), "".concat(_achActions.CREATE_PLAID_LINK_TOKEN, "_").concat(_httpActions.FAILURE), "".concat(_achActions.EXCHANGE_PLAID_PUBLIC_TOKEN, "_").concat(_httpActions.FAILURE), "".concat(_achActions.UPDATE_PLAID_ITEM, "_").concat(_httpActions.FAILURE), "".concat(_achActions.DELETE_PLAID_ITEM, "_").concat(_httpActions.FAILURE)), function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    error: (0, _util.payloadError)(action)
  });
}), _handleActions), initialState);
var _default = reducer;
exports.default = _default;